import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import TrashIcon from '../../../../../../../../components/icons/TrashIcon';

const propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  removeLabel: PropTypes.string,
  error: PropTypes.node,
  onRemove: PropTypes.func,
};

/**
 * One contact method: the input fills the row, the remove control sits beside
 * it, and any error reads underneath the input.
 *
 * @param {Object} props The component props.
 * @param {Node} props.children The input to lay out.
 * @param {String} [props.testId] Test id for the row.
 * @param {Boolean} [props.removable] Whether the row can be removed.
 * @param {Boolean} [props.disabled] Whether the row is read only.
 * @param {String} [props.removeLabel] Accessible name for the remove control.
 * @param {Node} [props.error] The error to show under the input.
 * @param {Function} [props.onRemove] Called when the row is removed.
 * @returns {Node} The rendered row.
 */
const ContactMethodRow = ({
  children,
  testId,
  removable,
  disabled,
  removeLabel,
  error,
  onRemove,
}) => (
  <div className="contact-method-row" data-testid={testId}>
    <div className="contact-method-row__field">
      {children}
      {removable && (
        <Button
          btnStyle="link"
          btnSize="sm"
          className="contact-method-row__remove"
          disabled={disabled}
          aria-label={removeLabel}
          onClick={onRemove}
        >
          <TrashIcon color="#fe5851" />
        </Button>
      )}
    </div>
    {error}
  </div>
);

ContactMethodRow.propTypes = propTypes;

export default ContactMethodRow;
